module.exports = __webpack_public_path__ + "media/images/wendys-artwork-black-331724c45c7ca2cf3a6dacb34b124ac1.png";